type GtmProps = Record<string, string | number | boolean | undefined | null>;

export function gtmEvent(event: string, props?: GtmProps): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  const payload: Record<string, unknown> = { event };
  if (props) {
    for (const [key, value] of Object.entries(props)) {
      if (value !== undefined && value !== null && value !== "") {
        payload[key] = value;
      }
    }
  }
  window.dataLayer.push(payload);
}
